exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_2XYs2 {\n    width: 100%;\n}\n\n.divContainerTwo_15GQe {\n    display: table;\n    width: 100%;\n}\n\n.columnTwo_1wr6R,\n.column_1_two_3-dY7 {\n    display: table-cell;\n    vertical-align: middle;\n}\n.columnTwo_1wr6R {\n    width: 2%;\n    padding-top: 7px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_2XYs2",
	"divContainerTwo": "divContainerTwo_15GQe",
	"columnTwo": "columnTwo_1wr6R",
	"column_1_two": "column_1_two_3-dY7"
};